import { MixPanel, Analytics } from "../../../../analytics";
import { getFromLocalStorage, LocalStorageKeys } from "../../../utils/localStorage";
import { getReferrerParam } from "../../../utils";
import api from "../../api";
import { serverPath } from "../../config";

export const sendOtpCode = (phoneNumber: string, isFbMessenger = false) => {
  const utmData = getFromLocalStorage(LocalStorageKeys.UtmData);
  const referrer = getReferrerParam();

  let anonymous = "";
  if (isFbMessenger && MixPanel) {
    anonymous = `&anonymous_id=${Analytics.getDistinctID()}`;
  }

  const additionalPath = isFbMessenger ? `?generateLink=true${utmData}${referrer}${anonymous}` : "";

  return api.post(serverPath.generateOtp + additionalPath, { phoneNumber });
};

export const getFromOtpAccessToken = (phoneNumber: string, otpNumber: number, country: string) =>
  api.post(serverPath.otpSignin, { phoneNumber, otpNumber, country });

export const getUTM = (phoneNumber: string, otp: string) =>
  api.get(`${serverPath.utm}?phoneNumber=${phoneNumber}&otp=${otp}`);

export const logOut = () => api.post(serverPath.logOut);
